import React, { useState, useEffect } from "react";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { getNews } from "../../../../api/index";
import { Pagination, ConfigProvider } from "antd";
import { useInView, animated } from "@react-spring/web";
import i18n from "i18next";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


function Index() {
  const { t } = useTranslation();
  const [datalist, setDataList] = useState([]);
  const pageSize = 10;
  const [mobile, setMobile] = useState(window.innerWidth < 1025);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const navigate = useNavigate();

  const [refFirst, styleFirst] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const onChange = (page) => {
    setPageNum(page);
  };

  const getList = async () => {
    const res = await getNews({
      pageNum: pageNum,
      pageSize: pageSize,
      classId: 1,
    });
    if (res.code === 200) {
      setDataList(res.data.list);
      setTotal(res.data.total);
      setTotalPage(res.data.totalPage);
    } else {
      toast.error("获取数据失败", { position: "top-center" });
    }
  };

  const goPrev = () => {
    if (pageNum !== 1) {
      setPageNum(pageNum - 1);
    } else {
      toast.info("已经是第一页了", { position: "top-center" });
    }
  };

  const goNext = () => {
    if (pageNum !== totalPage) {
      setPageNum(pageNum + 1);
    } else {
      toast.info("已经是最后一篇了", { position: "top-center" });
    }
  };

  useEffect(() => {
    getList();
  }, [pageNum]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={css.contain}>
      <div className={css.maintitle}>{t("新闻中心")}</div>
      <div className={css.first} ref={refFirst}>
        <animated.div style={styleFirst} className={css.inner}>
          {datalist.map((item, index) => {
            return (
              <div
                key={index}
                className={css.item}
                onClick={() => {
                  navigate(`/newsdetail`, { state: { id: item.pid } });
                }}
              >
                <div className={css.title}>{item.title}</div>
                <div className={css.time}>
                  {item.updatetime.split(" ")[0]}
                </div>
              </div>
            );
          })}
        </animated.div>
      </div>

      <div className={css.second}>
        {mobile ? (
          <div className={css.flexbox}>
            <div className={css.left} onClick={goPrev}>
              {t("上一页")}
            </div>
            <div className={css.right} onClick={goNext}>
              {t("下一页")}
            </div>
          </div>
        ) : (
          <ConfigProvider
            locale={i18n.language === "zh" ? zhCN : enUS}
            theme={{
              token: {
                colorPrimary: "#0d3988",
              },
            }}
          >
            <Pagination
              showQuickJumper
              showSizeChanger={false}
              current={pageNum}
              pageSize={pageSize}
              onChange={onChange}
              total={total}
            />
          </ConfigProvider>
        )}
      </div>
    </div>
  );
}

export default React.memo(Index);
